import ManualSelectionItem from "../models/selection-dropdown-item/ManualSelectionItem/ManualSelectionItem";
import type { SelectionDropdownItem } from "../models/selection-dropdown-item/types";

export function generateValuesBasedOnLimit(limit: number, multipliers: number[]) {
    const values = multipliers
        .map((multiplier) => Math.round((limit * multiplier) / 100) * 100)
        .concat(limit)
        .filter((v) => v > 0);

    return Array.from(new Set(values));
}

function getItemWithTheBiggestValue(items: readonly SelectionDropdownItem[]): SelectionDropdownItem | undefined {
    return items.reduce((assumedBiggest, item) => {
        if (item.value > assumedBiggest.value) {
            return item;
        }

        return assumedBiggest;
    }, items[0]);
}

function getItemWithTheSmallestValue(
    items: readonly SelectionDropdownItem[],
): SelectionDropdownItem | undefined {
    return items.reduce((assumedSmallest, item) => {
        if (item.value < assumedSmallest.value) {
            return item;
        }

        return assumedSmallest;
    }, items[0]);
}

export function getItemWithTheBiggestValueOrManual(items: readonly SelectionDropdownItem[]): SelectionDropdownItem {
    if (items.length === 0) {
        return new ManualSelectionItem(0);
    }

    return getItemWithTheBiggestValue(items) as SelectionDropdownItem;
}

export function getItemWithTheSmallestValueOrManual(items: readonly SelectionDropdownItem[]): SelectionDropdownItem {
    if (items.length === 0) {
        return new ManualSelectionItem(0);
    }

    return getItemWithTheSmallestValue(items) as SelectionDropdownItem;
}
